<div #compareCont id="compareCont" [class.show-compare-overlay]="showCompareOverlay && !slideCompareOverlayHighest"
 [class.show-compare-overlay-highest]="showCompareOverlay && slideCompareOverlayHighest" class="compare-container"
 (transitionend)="onTransitionend($event)" (click)="onOverlayClick($event)" (window:click)="closeOverlay($event, compareCont)"
 (window:keyup)="closeOverlay($event, compareCont)">
	<div class="clearfix">
		<div [class.upper-right-pos]="showCompareOverlay" class="compare-button-container" (click)="onCompareButtonClick($event)">
			<button id="cbtn" type="button" class="compare-button">{{'compare' | translate}} {{getTotal()}}/4</button>
		</div>
	</div>
	<div id="compareBody" class="compare-body" [class.show-compare-overlay-highest]="showCompareOverlay && slideCompareOverlayHighest"
	 (click)="onOverlayBodyClick($event)">
		<div *ngIf="screenWidth === 'LG' || screenWidth === 'XL'" class="compare-body-lg-xl">
			<div class="items-container-lg-xl">
				<div [class.item-margin-left-lg-xl]="i > 0" class="item-lg-xl" *ngFor="let compareItem of productCompare; let i = index">
					<div *ngIf="compareItem">
						<div>
							<button class="remove 17" type="button" (click)="removeProduct(compareItem)">{{ 'remove' | translate }}</button>
						</div>
						<div class="img-container">
							<img width="100%" height="auto" title="{{compareItem.displayName}}" src="{{compareItem.imageURL}}" alt="{{compareItem.displayName}}"
							 class="item-img" (load)="resizeImg($event.target, thumbnailW, thumbnailH, locale)" (error)="showImgError($event.target)">
						</div>
						<div class="item-name" [innerHTML]="compareItem.productTitle">
							<!-- {{compareItem.productTitle}} -->
						</div>
					</div>
					<div *ngIf="!compareItem">
						<div>
							<span class="remove not-visible 29">{{ 'remove' | translate }}</span>
						</div>
						<div class="img-container" style="visibility: visible;">
							<div class="no-image"></div>
						</div>
					</div>
				</div>
			</div>
			<div class="compare-link-container">
				<a class="compare-link cta-link-large" href="javascript:void(0)" (click)="goToComparePage()" [class.disabled]="!enableCompareBtn">{{'compare'
					| translate}}</a>
			</div>
		</div>
		<div *ngIf="screenWidth === 'MD'" class="compare-body-md">
			<div class="items-container-md">
				<div [class.item-margin-left-md]="i % 2 === 1" class="item-md" *ngFor="let compareItem of productCompare; let i = index">
					<div *ngIf="compareItem">
						<div>
							<button type="button" class="remove 47" (click)="removeProduct(compareItem)">{{ 'remove' | translate }}</button>
						</div>
						<div class="img-container">
							<img width="100%" height="auto" title="{{compareItem.displayName}}" src="{{compareItem.imageURL}}" alt="{{compareItem.displayName}}"
							 class="item-img" (load)="resizeImg($event.target, thumbnailW, thumbnailH, locale)" (error)="showImgError($event.target)">
						</div>
						<div class="item-name" [innerHTML]="compareItem.productTitle">
							<!-- {{compareItem.productTitle}} -->
						</div>
					</div>
					<div *ngIf="!compareItem">
						<div>
							<span class="remove not-visible 59">{{ 'remove' | translate }}</span>
						</div>
						<div class="img-container" style="visibility: visible;">
							<div class="no-image"></div>
						</div>
					</div>
				</div>
			</div>
			<div class="compare-link-container">
				<a class="compare-link cta-link-large 68" href="javascript:void(0)" (click)="goToComparePage()" [class.disabled]="!enableCompareBtn">{{'compare'
					| translate}}</a>
			</div>
		</div>
		<div *ngIf="screenWidth === 'SM'" class="compare-body-sm">
			<div class="items-container-sm">
				<div class="item-sm" *ngFor="let compareItem of productCompare; let i = index">
					<div *ngIf="compareItem">
						<div>
							<button type="button" class="remove 77" (click)="removeProduct(compareItem)">{{ 'remove' | translate }}</button>
						</div>
						<div class="img-container">
							<img width="100%" height="auto" title="{{compareItem.displayName}}" src="{{compareItem.imageURL}}" alt="product image"
							 class="item-img" (load)="resizeImg($event.target, thumbnailW, thumbnailH, locale)" (error)="showImgError($event.target)">
						</div>
						<div class="item-name" [innerHTML]="compareItem.productTitle">
							<!-- {{compareItem.productTitle}} -->
						</div>
					</div>
					<div *ngIf="!compareItem">
						<div>
							<span class="remove not-visible 89">{{ 'remove' | translate }}</span>
						</div>
						<div class="img-container" style="visibility: visible;">
							<div class="no-image"></div>
						</div>
					</div>
				</div>
			</div>
			<div class="compare-link-container">
				<a class="compare-link cta-link-large 98" href="javascript:void(0)" (click)="goToComparePage()" [class.disabled]="!enableCompareBtn">{{'compare'
					| translate}}</a>
			</div>
		</div>
	</div>
</div>
